import { environment } from "../../environments/environment";

export class ApplicationUrlSettings{

    public static PHP_API_URL = environment.PHP_API_URL;
    public static NODE_API_URL = environment.NODE_API_URL;
    

    public static USER_INFO = "users/info";

    public static TIME_SLOT = "timeslot";

    public static CLUSTER_POINTS = "getMatrixForAreas";

    public static CHANGE_REQUEST = "submitAddressChange";

    public static RATE_TRIP = "rateTrip";

    public static GET_RATINGS = "getRating";

    public static RESET_PASSWORD = "resetPasswordLink";

    public static SET_NEW_PASSWORD = "setNewPassword";

    public static CHECK_PEND_ADDR_CHANGE = "hasPendingAddressChange";

    public static GET_ALL_PEND_ADDR_CHANGE = "getPendingAddressChange";

    public static APPROVE_ADDR = "approveAddressChange";

    public static DECLINE_ADDR = "declineAddressChange";

    public static ADMIN_LOGIN = "admin/login";

    public static IS_VALID_LOGIN = "isAdminLoggedIn";

    public static CREATE_ADMIN = "admin";

    public static OPTIMIZE: string = "optimize";

    public static REVERSE_GEOCODE :string = "reverseGeocode";

    public static REGISTER_USERS: string = "registerUsers";
    //nodejs api
    public static REGISTER_USERS_API: string = "upload"
    //
    public static GET_DEPARTMENTS: string = "Departments";

    public static GET_VEHICLES_BY_BATCH_ID = "getVehiclesByBatchId";

    public static PUBLISH_REPORT: string = "publishReport";

    public static GET_REPORT_SINGLE: string = "singleReport";

    public static GET_DIRECTIONS:string = "directions";

    public static GET_USER_WEEKS: string = "getUserWeeks";

    public static GET_REPORT_DETAILS:String = "userReportDetails";

    public static DRIVER : string = "driver";

    public static ADD_USER_PICKUP:string = "addUserPickup";

    public static BATCH_UPLOAD:string = "batchupload";

    public static BULK_CACHE = "cachePoints";

    public static BULK_REG_EMAIL  = "sendBUlkRegEmails";

    public static REG_EMAIL  = "sendRegEmail";


    public static GET_USER_BY_COMP: string = "getUserByCompany";

    public static REMOVE_USER_RUN:string = "removeUserFromRun";

    public static MOVE_USER_RUN:string = "moveUserFromRun";

    public static GET_BATCH_UPLOAD_TEMPLATE_FOR_ALL = "getBatchUploadTemplateForAll";

    public static GET_RUN_HIST = "getRunHistory";

    public static GET_REPORTS = "getReports";

    public static UPDATE_HOUR = "reports/hour";

    public static TRIP = "trip";

    public static DEACTIVATE_COMP_LOC = "companylocation";

    public static INSERT_COMPANY_LOC = "companylocation";

    public static CREATE_COMPANY = "company";

    public static GET_COMPANY = "company";

    public static GET_CLIENTS = "client/list";

    public static GET_COMPANY_TRIPS = "client/trips";

    public static EMPLOYEE_ID = "employeeid";

    public static CREATE_USER:string = "createUser";

    public static COMPLETE_USER_REG:string = "users/complete-registration";

    public static CLAIM:string = "users/claim";

    public static UPDATE_USER_ADDRESS:string = "updateUserAddress";

    public static GET_USER:string = "user";

    public static aukwhxbasuaksyaj:string = "aukwhxbasuaksyaj";

    public static IS_USER_REG:string = "checkUserReg";

    public static GET_USER_BY_EMAIL = "userByEmail";
    public static GET_USER_BY_EMP_ID = "users/userByEmployeeId";

    public static UPDATE_USER:string = "user";

    public static OPTIMIZER_RESULT: string = "optimizerResult";

    public static RUN_HISTORY = "runhistory";

    public static REPORTS = "reports";

    public static DISTANCE_MATRIX: string = "distanceMatrix";

    public static C_DISTANCE_MATRIX: string = "cDistanceMatrix";

    public static GET_REPORT_FOR_WEEK:string = "getReportForWeek";

    public static GET_WEEK:string = "getWeek";

    public static CLOSEST_POINT:string = "closestPoint";

    public static VEHICLE_TYPE : string = "vehicletype";

    public static VEHICLE: string = "vehicle";

    public static GET_COMPANY_LOCATION_VEHICLES = "getCompanyLocationVehicles";

    public static CHECK_EMAIL_EXIST :string = 'users/checkEmailExist';

    public static GET_WEEKS = "week";

    public static DELETE_VEHICLES = "deletevehicles";

    public static USER_LOGIN:string = "users/login";

    public static CLIENT_LOGIN:string = "client/login";

    public static BUS_PAS:string = "users/buspass";

    public static BULK_CREATE_VEHICLE:string = "bulkCreateVehicles";

    public static GET_AVAILABLE_VEHICLES = "getAvailableVehicles";

    public static GET_ALL_USER_TRAVEL_INFO = "getAllUserTravelInfo";

    public static GET_REGISTERED_USERS = "getRegisteredUsers";

    public static GET_UNREGISTERED_USERS = "getUnregisteredUsers";

    public static GET_TOTAL_USERS = "getTotalUsers";

    public static GET_UNCACHED_USERS = "getUncachedUsers";

    public static GENERATE_CSV = "generatecsv";

    public static RANDOM = "random";

    public static JSON_TO_CSV = "jsonToCsvFile";

    public static CSV_TO_JSON = "csvtojson";

    public static EXPORT_USERS = "registered-users/download";

    public static USERS = "users";

    public static OPTIMAL_POS = "optimalPasengerPosition";

    public static DOWNLOAD_CSV = "downloadcsv/";

    public static PDF_REPORT = "pdfReport";

    public static UPLOAD = "batchupload";

    public static ADMIN_SETTINGS = "settings";

    public static SELECT_SETTING = "selectSetting";

    public static GET_SELECTED_SETTING = "getSelectedSetting";

    public static CHECK_CACHE_SCHEDULER_STATUS = "checkJobStatus/CACHESCHEDULER";

    public static RESTART_CACHE_SCHEDULER = "restartCacheScheduler";

    public static STOP_CACHE_SCHEDULER = "stopCacheScheduler";

    public static CHANGE_CACHE_SCHEDULER_INTERVAL = "changeSchedulerInterval";

    public static GET_CACHE_SCHEDULER_INTERVAL = "getCacheSchedulerInterval";

    public static  CACHE = "cache";

    public static LOOK_UP = "getCachedResponse";

    public static GET_RESPONSE_BY_ID = "getResponseById/"; 

    public static CHANGE_COMPANY_STATUS = "client/toggle-status";

    public static DELETE_COMPANY = "client/delete";

    public static RESTORE_COMPANY = "client/restore";

    public static UPDATE_COMPANY = "client/company-locations";

    public static GET_CLIENTS_API = "main-client/list";

    public static CREATE_CLIENT_API = "main-client/create";

    public static UPDATE_CLIENT_API = "main-client/update";

    public static DELETE_CLIENT_API = "main-client/delete";

    public static RESTORE_CLIENT_API = "main-client/restore";

    public static CHANGE_CLIENT_STATUS_API = "main-client/toggle-status";


    //Administrator APIs
    public static GET_ADMINISTRATORS_API = "main-client/administrators";
    public static DELETE_ADMINISTRATORS_API = "main-client/administrator/delete";
    public static ACTIVATE_DEACTIVATE_ADMINISTRATORS_API = "main-client/administrator/toggle-status";
    public static RESTORE_ADMINISTRATORS_API = "main-client/administrator/restore";
    public static CHANGE_ADMIN_ROLE_API = "main-client/administrator/role";
    public static SEND_RESET_PASSWORD_API = "main-client/administrator/reset-password";
}


// WEBPACK FOOTER //
// ./src/app/settings/ApplicationUrlSettings.ts